export default __webpack_public_path__ + "static/media/22_thumbnail.0743f52d.JPG";